import styled from '@emotion/styled'

export const ResumeContainer = styled.div`
  width: 100%;
  max-width: 500px;
`
